import React, { useState, useRef } from "react";
import NavHeader from "../navigation/NavHeader";
import AsideLeft from "../aside/AsideLeft";
import AsideRight from "../aside/AsideRight";
import Footer from "../navigation/Footer";
import GoUpDown from "../navigation/GoUpDown";
import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS, CallBackProps } from 'react-joyride';
import { joyrideSteps } from '../../utils/tourData';

const finishedTourConfig = localStorage.getItem("finished-tour");
const finishedTour = finishedTourConfig === "true";



const MainLayout = (props) => {
    const { currentPage } = props;
    const mobileChatClasses = props?.mobileChatClasses ?? "";
    const showAsideLeft = props?.showAsideLeft ?? true;
    let ads = [];
    if (props.ads) {
        ads = [...props.ads];
    }

    const steps = joyrideSteps;
    const [startTour, setStartTour] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const tourRenderRef = useRef(1);



    const handleStartTour = () => {
        setStartTour(true);
        tourRenderRef.current = tourRenderRef.current + 1;
    }

    const handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;

        if (action === ACTIONS.CLOSE) {
            // do something
            setStepIndex(0);
            setStartTour(false);
        }

        if (STATUS.SKIPPED == status) {
            const nextIndex = index + 2;
            if (nextIndex > steps.length - 1) {
                setStepIndex(0);
                setStartTour(false);
            } else {
                setStepIndex(nextIndex);
                setStartTour(false);
                setTimeout(() => {
                    setStartTour(true);
                }, 150);
            }
        } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            // Update state to advance the tour
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        } else if ([STATUS.FINISHED].includes(status)) {
            // You need to set our running state to false, so we can restart if we click start again.
            setStartTour(false);
        }
    }

    // className={`${currentPage === 'chat' ? 'fixed overflow-y-scroll' : 'flex min-h-full overflow-y-auto flex-col'}`}
    // style={{ "-webkit-overflow-scrolling": "touch" }}
    return (

        <div
            className={`relative flex overflow-hidden flex-col ${currentPage === 'chat' ? ' h-screen ' : ''} md:min-h-full `}
        >

            <Joyride
                steps={steps}
                stepIndex={stepIndex}
                run={startTour}
                continuous={true}
                showProgress={true}
                showSkipButton={false}
                callback={handleJoyrideCallback}
                disableScrolling={true}
                styles={{
                    options: {
                        arrowColor: '#6b21a8',
                        primaryColor: '#6b21a8'
                    },
                }}
            />
            {/*  max-w-[80%] */}
            <NavHeader currentPage={currentPage} mobileChatClasses={mobileChatClasses} />
            {currentPage !== 'addpost' &&
                <div className={`flex flex-col md:flex-row w-screen self-center  items-start justify-center gap-x-2 px-[5px]  lg:hidden  ${currentPage === 'chat' && mobileChatClasses.indexOf('hidden') >= 0 ? ' md:px-[8px] ' : ' md:px-[5px] pt-[57px]'}  md:pt-[58px] `}>
                    <AsideRight className="" ads={ads} />
                </div>
            }
            <div className={`flex flex-col md:flex-row w-screen self-center  items-start justify-center gap-x-2 px-[5px]  ${currentPage === 'chat' && mobileChatClasses.indexOf('hidden') >= 0 ? ' md:px-[4px] ' : 'pt-0 md:pt-[5px]'}  lg:pt-[57px] `}>
                {showAsideLeft &&
                    <>
                        <AsideLeft shows={'leaderboard'} handleStartTour={handleStartTour} />
                    </>
                }
                {/* flex-1 flex-grow self-stretch sm:max-w-screen md:max-w-4xl*/}
                <main className={`flex flex-col flex-1 w-full sm:max-w-screen ${currentPage === 'chat' ? 'md:max-w-[calc(100vw-15px)] md:overflow-x-hidden md:mt-1 lg:mt-0 xl:max-w-4xl' : 'md:max-w-[calc(100vw-246px)] lg:max-w-[calc(100vw-475px)] xl:max-w-2xl'} `}>
                    {props.children}
                </main>

                <AsideRight className="hidden lg:block" ads={ads} />
            </div>
            <Footer currentPage={currentPage} mobileChatClasses={mobileChatClasses} />
            <GoUpDown />
        </div>
    );
};

export default MainLayout;
